<template>
  <button class="custom-btn" v-bind:style="style" v-on:click="onClick()">
    <slot v-if="!loading"></slot>
    <i v-else class="fa fa-spinner fa-spin"></i>
  </button>
</template>

<style lang="scss" scoped>
@import "../../assets/styles/partials/variables";
.custom-btn {
  color: #fff;
  background: $primary-button;
  border-radius: 0.25rem;
  padding: 0.5rem 1rem;
  letter-spacing: 1px;
  text-align: center;
  @media (max-width: 768px) {
    width: 10rem;
    margin: 0 auto;
  }
  &:hover {
    background: rgba($primary-button, 0.6);
    cursor: pointer;
  }
}
</style>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false
    },
    danger: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {};
  },
  computed: {
    style() {
      if (this.danger) {
        return { background: '#dc3545' };
      } else {
        return {};
      }
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  },
  created() {}
};
</script>
